import { render, staticRenderFns } from "./mvInfo.vue?vue&type=template&id=5c14154b"
import script from "./mvInfo.vue?vue&type=script&lang=js"
export * from "./mvInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports